import { ChangeDetectionStrategy, Component } from '@angular/core';

import { RouterLink } from '@angular/router';

@Component({
    selector: 'app-price',
    templateUrl: './price.component.html',
    styleUrls: ['./price.component.css'],
    imports: [RouterLink],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PriceComponent {

}

